module.exports = __webpack_public_path__ + "img/together.0743f2af.webp";